import getDeclension from '@/core/helpers/get-declension';

export default {
    computed: {
        foundItemsNumber() {
            if (this.localValues) {
                return '';
            }

            const foundItemsDeclensions = [
                this.$t('results.foundNumberItems.declension.first', [this.totalItemsCount]),
                this.$t('results.foundNumberItems.declension.second', [this.totalItemsCount]),
                this.$t('results.foundNumberItems.declension.third', [this.totalItemsCount]),
            ];

            return getDeclension(this.totalItemsCount, foundItemsDeclensions);
        },
    },
};
